<template>
  <div>
    <h1>Collabs</h1>
    <!-- <a target="_blank" rel="noopener noreferrer" class="btn" href="https://youtu.be/1MWwjAutl7o?t=700">HELP: how to use collabs...</a> -->
    <div v-if="creator.collabs.collabs.length" class="collabs-section">
      <h4>AVERAGE COLLAB STATS:</h4>
      <div class="collab-card">
        <div class="collabs-right-section">
          <p>{{avgStat()}} videos</p>
          <p>{{formatSubsAvg(avgStat('avgSubs'))}} subs</p>
          <h4 v-if="youtube.channelStatistics" >{{gradeCalculator(avgSubs)}}</h4>
        </div>
      </div>
    </div>
    <button v-if="creator.collabs.collabs.length"
      class="keyword-button"
      v-b-modal.addCollab>+
    </button>
    <div v-if="creator.collabs.collabs.length" class="collabs-section">
      <div v-for="collab in creator.collabs.collabs" :key="collab.collabID" class="collab-card">
        <div class="collabs-left-section">
          <img :src="collab.data.thumbnailUrl.url" class="collabs-channel-icon">
          <h4 class="long-video-title">{{collab.data.channelName}}</h4>
        </div>
        <div class="collabs-right-section">
          <p class="">{{collab.data.videoCount}} videos</p>
          <p class="">{{formatSubs(collab.data)}} subs</p>
          <p v-if="youtube.channelStatistics" class="collabs-grade">{{gradeCalculator(collab.data.subscriberCount)}}</p>
        </div>
        <i class="left fa fa-trash" @click="selectCollab(collab)" v-b-modal="'deleteCollab'+collab.collabID"></i>
        <b-modal :id="'deleteCollab'+collab.collabID" title="Are you sure you want to delete this collab?" centered @ok="deleteCollab(collab)">
        </b-modal>
      </div>
    </div>
    <div v-else class="collabs-header">
      <h4>No collabs yet! Add one now...</h4>
      <button
        class="keyword-button"
        v-b-modal.addCollab>+
      </button>
    </div>
    <div class="mb-4">
      <b-modal id="addCollab" title="Add Collab" centered @ok="addNewCollab">
        <b-form>
          <b-form-group
            label="New Collab"
            description="Copy and paste YouTube URL here..."
          >
            <b-form-input
              v-model="newCollab"
              type="text"
              autocomplete="off"
              placeholder="https://www.youtube.com/channel/UC7O8KgJdsE_e9op3vG-p2dg"
              required
            ></b-form-input>
          </b-form-group>
        </b-form>
      </b-modal>
      <b-modal id="searchResults" title="Who you were looking for?" centered hide-footer>
        <div class="video-metadata">If no results, go back and try searching the channel name (i.e. "Graham Stephan" instead of "https://www.youtube.com/c/GrahamStephan".</div>
        <div v-if="searchList" class="long-video-section">
          <div v-for="channel in searchList" :key="channel.id.channelId" class="long-video-container" @click="addAdjustedCollab(channel)">
            <div class="long-thumbnail">
              <img :src="channel.snippet.thumbnails.default.url" class="kit__utils__avatar kit__utils__avatar--rounded kit__utils__avatar--size84">
            </div>
            <div class="long-video-right-section">
              <div class="long-video-title">{{channel.snippet.title}}</div>
              <div class="video-metadata" v-if="channel.stats">
                <span>{{channel.stats.statistics.videoCount}} videos</span>
                •
                <span class="collabs-stats">{{formatSubs(channel.stats.statistics)}} subscribers</span>
              </div>
              <div class="long-video-metadata">
                {{channel.snippet.description}}
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
// import { firebaseDatabase, firebaseAuth } from '@/services/firebase'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'collabs',
  data() {
    return {
      newCollab: null,
      param: null,
      searchList: null,
      selectedCollab: {
        channelName: '',
      },
      avgSubs: null,
      // avgVids: null,
    }
  },
  computed: {
    ...mapState(['creator']),
    // ...mapState(['collabs']),
    ...mapState(['youtube']),
  },
  methods: {
    avgStat(stat) {
      const data = this.creator.collabs.collabs
      const [subTotals, vidTotals] = data.reduce(function(acc, val) {
        acc[0] += Number(val.data.subscriberCount)
        acc[1] += Number(val.data.videoCount)
        return acc
      }, [0, 0])
      const avgSubs = Math.round(subTotals / data.length)
      const avgVids = Math.round(vidTotals / data.length)
      if (stat === 'avgSubs') {
        return avgSubs
      } else return avgVids
    },
    gradeCalculator(subscriberCount) {
      const yourSubs = subscriberCount
      const mySubs = this.youtube.channelStatistics.subscriberCount
      if (yourSubs <= 1000 && mySubs <= 1000) {
        return 'A'
      } else if (yourSubs >= (mySubs * 0.8) && yourSubs <= (mySubs * 5)) {
        return 'A'
      } else if (yourSubs >= (mySubs * 0.6) && yourSubs <= (mySubs * 6)) {
        return 'B'
      } else if (yourSubs >= (mySubs * 0.4) && yourSubs <= (mySubs * 7.5)) {
        return 'C'
      } else if (yourSubs >= (mySubs * 0.1) && yourSubs <= (mySubs * 10)) {
        return 'D'
      } else return 'F'
    },
    selectCollab(collab) {
      this.selectedCollab = collab
    },
    async addNewCollab() {
      // youtube.com/c/
      // youtube.com/user/
      // youtube.com/channel/
      // youtube.com/
      const term = this.newCollab.slice(24)
      const snippet = async () => {
        const apiSnippetUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=snippet&${this.param}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
        var channelSnippet =
          axios
            .get(apiSnippetUrl)
            .then(res => {
              console.log(res)
              return res.data.items[0]
            })
        return channelSnippet
      }
      const statistics = async () => {
        const apiStatisticsUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=statistics&${this.param}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
        var channelStatistics =
          axios
            .get(apiStatisticsUrl)
            .then(res => {
              return res.data.items[0]
            })
        return channelStatistics
      }
      if (term.search('/') === 4) {
        console.log('user/')
        this.param = 'forUsername=' + term.substr(5)
        const snippet1 = await snippet()
        const statistics1 = await statistics()
        const payload = {
          // channelid,
          snippet1,
          statistics1,
          collabURL: this.newCollab,
        }
        this.$store.commit('creator/collabs/insertCollab', payload)
        this.setHasChanges('create', {
          collab: {
            change: 'create',
          },
        })
      } else if (term.search('/') === 7) {
        console.log('channel/')
        this.param = 'id=' + term.substr(8)
        console.log(this.param)
        const snippet1 = await snippet()
        const statistics1 = await statistics()
        const payload = {
          // channelid,
          snippet1,
          statistics1,
          collabURL: this.newCollab,
        }
        this.$store.commit('creator/collabs/insertCollab', payload)
        this.setHasChanges('create', {
          collab: {
            change: 'create',
          },
        })
      } else this.searchCollabs(this.newCollab)
      this.newCollab = null
    },
    searchCollabs(searchTerm) {
      const statistics = async (channelId) => {
        const apiStatisticsUrl = `https://youtube.googleapis.com/youtube/v3/channels?part=statistics&id=${channelId}&key=AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc`
        var channelStatistics =
          axios
            .get(apiStatisticsUrl)
            .then(res => {
              return res.data.items[0]
            })
        return channelStatistics
      }
      const apiKey = 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc'
      axios
        .get(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=5&q=${searchTerm}&type=channel&key=${apiKey}`)
        .then(res => {
          this.searchList = res.data.items
          const mapChannels = async() => {
            return Promise.all(this.searchList.map(async function (channel) {
              console.log(channel.id)
              const stats = await statistics(channel.id.channelId)
              return {
                id: channel.id,
                snippet: channel.snippet,
                stats,
              }
            }))
          }
          mapChannels().then(data => {
            this.searchList = data
          })
        })
        .catch(error => console.log(error))
      this.$bvModal.show('searchResults')
    },
    addAdjustedCollab(channel) {
      const snippet1 = {
        snippet: {
          title: channel.snippet.channelTitle,
          thumbnails: channel.snippet.thumbnails,
        },
      }
      const statistics1 = {
        statistics: {
          subscriberCount: channel.stats.statistics.subscriberCount,
          videoCount: channel.stats.statistics.videoCount,
        },
      }
      const payload = {
        snippet1,
        statistics1,
        collabURL: 'https://www.youtube.com/channel/' + channel.id.channelId,
      }
      this.$store.commit('creator/collabs/insertCollab', payload)
      this.setHasChanges('create', {
        collab: {
          change: 'create',
        },
      })
      this.$bvModal.hide('searchResults')
      this.searchList = null
    },
    formatSubs(collab) {
      const originalViews = collab.subscriberCount
      if (originalViews < 1000) {
        return collab.subscriberCount
      } else if (originalViews < 1100) {
        return '1K'
      } else if (originalViews < 10000) {
        return (Math.round(originalViews / 1000 * 10) / 10 + 'K')
      } else if (originalViews < 1000000) {
        return (Math.round(originalViews / 1000) + 'K')
      } else if (originalViews < 1100000) {
        return '1M'
      } else if (originalViews < 10000000) {
        return (Math.round(originalViews / 1000000 * 10) / 10 + 'M')
      } else return (Math.round(originalViews / 1000000) + 'M')
    },
    formatSubsAvg(avgSubs) {
      const originalViews = avgSubs
      if (originalViews < 1000) {
        return originalViews
      } else if (originalViews < 1100) {
        return '1K'
      } else if (originalViews < 10000) {
        return (Math.round(originalViews / 1000 * 10) / 10 + 'K')
      } else if (originalViews < 1000000) {
        return (Math.round(originalViews / 1000) + 'K')
      } else if (originalViews < 1100000) {
        return '1M'
      } else if (originalViews < 10000000) {
        return (Math.round(originalViews / 1000000 * 10) / 10 + 'M')
      } else return (Math.round(originalViews / 1000000) + 'M')
    },
    deleteCollab(collab) {
      this.$store.commit('creator/collabs/removeCollab', collab)
      this.setHasChanges('delete', collab)
      // firebaseDatabase.collection('collabs').doc(this.selectedCollab.collabID).delete()
      // this.$store.commit('collabs/removeCollab', removedCollabID)
    },
    setHasChanges(type, collab) {
      this.$store.commit('creator/hasChanges')
      if (type === 'delete') {
      } else if (collab.change === 'create') {
      } else collab.change = 'update'
    },
    calculateAverages() {
      const data = this.creator.collabs.collabs
      const [subTotals, vidTotals] = data.reduce(function(acc, val) {
        acc[0] += Number(val.data.subscriberCount)
        acc[1] += Number(val.data.videoCount)
        return acc
      }, [0, 0])
      this.avgSubs = Math.round(subTotals / data.length)
      this.avgVids = Math.round(vidTotals / data.length)
    },
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
